<template>
<div class="chapter">
<div class="inner_page">
<div id="dabef9d1bfb79-d1e394"><span id="pageix">
<p class="prelims-epigraph-first">‘The legacy of heroes is the memory of a great name and the inheritance of a great example.’</p>
<p class="prelims-epigraph-source-space-after">Benjamin Disraeli</p>
<p class="prelims-epigraph">To the one who has gone before, the great master of horseracing novels, Dick Francis, thank you for all those wonderful reads. I offer my sincere gratitude and humbly follow in your footsteps.</p>
<p class="prelims-epigraph-source">Glenis Wilson</p></span></div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781780106403_epub_epi.vue?7ba2485e